import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const ChecklistFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default ChecklistFilter;